import AppBar from "@mui/material/AppBar";
import * as React from "react";
import {Container, Toolbar} from "@mui/material";
import YouTubeIcon from '@mui/icons-material/YouTube';
import Typography from "@mui/material/Typography";
import styles from "../styles/Header.module.css";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {useNavigate} from "react-router-dom";

const pages = [
    {
        name: "Home",
        url: "https://parmarthsadhna.in/",
        icon: "",
        internal: false
    },
    {
        name: "YouTube",
        url: "https://www.youtube.com/channel/UCcLMJnIYfb9cFy56F2vWBUw/videos",
        icon: <YouTubeIcon style={{ float: "inline-start", marginRight: "5px" }} />,
    }
];

export default function Header({scrollTo = ()=>{} }) {
    const navigate = useNavigate();

    const handleClick = (page) => () => {
        if (page.internal) {
            window.location=page.url;
    
        } else {
            window.open(page.url,"_self");
        }
    };

    return (
        <div>
            <AppBar position="sticky" color="#fff" style={{backgroundColor: "#fff"}}>
                <Container maxWidth="xl">
                    <Toolbar disableGutters style={{justifyContent: "center"}}>
                        <img className={styles.logo} src="/events/img.png" alt="Parmarth Sadhna logo"/>
                        <Typography className={styles.headerLogoTitle}>
                            Parmarth Sadhna Charitable Trust Global Events
                        </Typography>
                    </Toolbar>
                </Container>
            </AppBar>
            <AppBar position="static" style={{backgroundColor: "#000", alignItems: "center"}}>
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        <Box sx={{ flexGrow: 1, display: 'flex' }} style={{justifyContent: 'center'}}>
                            {pages.map((page) => (
                                <Button
                                    key={page.name}
                                    variant="text"
                                    onClick={handleClick(page)}
                                    sx={{ my: 1, color: 'white', display: 'block' }}
                                >
                                    {page.icon} {page.name}
                                </Button>
                            ))}
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
        </div>
    )
}